import ConfigSagas from "../sagas/configSagas";
import LoginSagas from "../sagas/loginSagas";
import GenerateUsernamesSagas from "../sagas/generateUsernamesSagas";
import GetAllAdGroupsSagas from "../sagas/getAllAdGroupsSagas";
import GenerateAdUsersSagas from "../sagas/generateAdUsersSagas";
import GetIssueIdOrKeySagas from "../sagas/getIssueIdOrKeySagas";
import { fork, take, cancel, all } from "redux-saga/effects";

const CANCEL_SAGAS_HMR = "CANCEL_SAGAS_HMR";

function* rootSaga() {
    yield all([
        ...ConfigSagas,
        ...LoginSagas,
        ...GenerateUsernamesSagas,
        ...GetAllAdGroupsSagas,
        ...GenerateAdUsersSagas,
        ...GetIssueIdOrKeySagas
    ]);
}


function createAbortableSaga(saga: any) {
    if (process.env.NODE_ENV === "development") {
        return function* main() {
            const sagaTask = yield fork(saga);
            yield take(CANCEL_SAGAS_HMR);
            yield cancel(sagaTask);
        };
    }

    return saga;
}

const SagaManager = {
    startSaga(sagaMiddleware: any) {
        const rootTask = sagaMiddleware.run(createAbortableSaga(rootSaga));

        rootTask.toPromise().catch((err: any) => {
            console.log("Error in Sagas", err); //eslint-disable-line
        });

        return rootTask;
    },

    cancelSaga(store: any) {
        store.dispatch({ type: CANCEL_SAGAS_HMR });
    }
};

export default SagaManager;